import React from 'react'
import '../css/error.css'
import { motion } from "framer-motion";

const Unauth = () => {
  return (
    <motion.div
    initial={{ x: "-100vw" }}
    animate={{ x: 0 }}
    transition={{ duration: 1, type: "spring" }} className='container-fluid'>
    <div className='row justify-content-center'>
      <div className='col-12 col-md-6 text-center'>
      <div class="number">401</div>
      
      </div>
    </div>
    <div className='row justify-content-center'>
      <div className='col-12 col-md-6 text-center'>
    <div class="text"><span>Shhhh...</span>
    <br/> Unauthorised Access.....!!!!</div>
      </div>
    </div>
  </motion.div>
     )
}

export default Unauth
